export default "__VITE_ASSET__32859703__"